// @ts-nocheck

import React from 'react';
import moment from 'moment';

import Modal from '../../../../../../../components/ant/Modal';

import { formatDateTimeToISOString } from './../../../../../../../lib/helpers';
import { contractVehicleTypeEnum } from './../../../../../../../lib/enum';

import ContractVehicleInnerForm from './../../../../../../ContractVehicles/components/InnerForm';







export default (props) => {
  const { visible, onCancel, orgUnitId, addContractVehicle } = props;
  const formatDate = (value) => {
    return value ? moment.utc(value) : value;
  };
  return (
    <Modal
      destroyOnHidden
      width={800}
      title="Добавление нового ТС"
      visible={visible}
      onCancel={onCancel}
      footer={null}>

      <ContractVehicleInnerForm
        vehicle={{
          type: contractVehicleTypeEnum.fixedPlan,
          vehicle: {
            orgUnitId,
            usingNodeId: orgUnitId
          }
        }}
        hideFields={['type', 'orgUnitId', 'usingNodeId']}
        onCancel={onCancel}
        onSubmit={addContractVehicle}
        formatDate={formatDate}
        changeDate={formatDateTimeToISOString}
        sectionStyle={{ boxShadow: 'none', margin: '0px' }} />

    </Modal>);

};
